/**
 * ============================================================================
 * GENERATED FILE - Created via: pnpm run generate:wetags
 * ============================================================================
 *
 * This file was generated by the wetag library generator.
 *
 * To add new entity types or update configuration, run:
 *   pnpm run generate:wetags
 *
 * You can safely modify this file if needed, but using the generator
 * ensures consistency across all wetag libraries in the codebase.
 *
 * To add type-safe tag names, update the tags.ts file in this directory.
 * ============================================================================
 */

import { createNamespacedWetagHooksForOrg } from '@frontend/wetags';
import type { NextGenSettingsTags } from './tags';

const NEXT_GEN_SETTINGS_NAMESPACE = 'weave-location';

export const NextGenSettingsOrg = createNamespacedWetagHooksForOrg<NextGenSettingsTags>(NEXT_GEN_SETTINGS_NAMESPACE);
